/**
 * As duas listas de mensagens dizem a mesma coisa?
 *
 * ## Por que isto existe
 *
 * Quase todo evento do chat devolve a CONVERSA INTEIRA, não o que mudou:
 * `PUT /messages/read` e `PUT /messages/delivered` respondem com todas as
 * mensagens da sala, e o ws retransmite essa resposta para quem está nela.
 *
 * Isso faz com que abrir uma sala com 10 mensagens não lidas gere 10 idas ao
 * servidor (uma por mensagem, em `messageReadFocus`), 10 respostas com a
 * conversa toda e 10 retransmissões -- e, como cada resposta chega num ARRAY
 * NOVO, 10 re-renderizações completas do chat, das quais 9 desenham exatamente
 * a mesma tela.
 *
 * Com esta comparação o `useChat` devolve o estado anterior quando o conteúdo
 * é igual, e o React desiste do render. O número de requisições não muda --
 * isso é desenho de protocolo, não de componente -- mas o trabalho de tela
 * desaparece.
 *
 * ## Por que comparar o JSON inteiro, e não só `id` + `read_at`
 *
 * Uma assinatura curta seria mais rápida e seria ERRADA no sentido perigoso:
 * qualquer campo fora dela (o texto de uma mensagem editada, `meta.ack`, um
 * anexo) mudaria sem a tela perceber, e o operador ficaria olhando um estado
 * velho. Comparar tudo só erra na direção segura -- no máximo deixa de
 * economizar um render.
 */
export const mesmaListaDeMensagens = (a, b) => {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;

    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch {
        // Referência circular ou algo exótico: não afirma igualdade.
        return false;
    }
};
